import React from "react";
import { styled } from "@mui/system";

const Wrapper = styled("div")(() => ({
  display: "flex",
  width: "100%",
  padding: "16px 0px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: "16px",
  borderRadius: "16px",
  background: " #FFF",
}));

const HeaderAndText = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  alignSelf: "stretch",
}));

const TextBold = styled("div")(() => ({
  alignSelf: "stretch",
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "19px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "23px",
  letterSpacing: "-0.38px",
}));

const TextNormal = styled("div")(() => ({
  alignSelf: "stretch",
  color: "#002035",
  fontFamily: "Söhne",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "17px",
}));

const RedSpan = styled("span")(() => ({
  color: "#FC4C4C",
  fontFamily: "Roobert",
  fontSize: "19px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "23px",
  letterSpacing: "-0.38px",
}));

const IconAndText = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
}));

const IconWrapper = styled("div")(() => ({
  display: "flex",
  width: "12px",
  height: "10.691px",
  padding: "0.194px 0.038px 0.024px 0.062px",
  justifyContent: "center",
  alignItems: "center",
}));

interface InfoBlockProps {
  title: string;
  highlightText: string;
  boldText: string;
  infoText: string;
}

/**
 * A component to display information with a title, highlight text, bold text, and additional info text.
 * @param {string} props.title - The title of the information block.
 * @param {string} props.highlightText - The highlighted text within the bold text.
 * @param {string} props.boldText - The bold text with the highlighted text.
 * @param {string} props.infoText - The additional information text.
 */
const InfoBlock = (props: InfoBlockProps) => {
  const { title, highlightText, boldText, infoText } = props;
  return (
    <Wrapper>
      {/* Header and Text */}
      <HeaderAndText>
        <TextNormal>{title}</TextNormal>
        <TextBold id="RaF-tradeAmount">
          <RedSpan>{highlightText}</RedSpan> {boldText}
        </TextBold>
      </HeaderAndText>

      {/* Icon and Text */}
      <IconAndText>
        <IconWrapper>
          <DiamondIcon />
        </IconWrapper>
        <TextNormal id="RaF-infoText">{infoText}</TextNormal>
      </IconAndText>
    </Wrapper>
  );
};

export default InfoBlock;

const DiamondIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
      <path
        d="M3.14558 0.34854C3.0468 0.34854 2.9522 0.378887 2.87305 0.433629L3.6591 3.71053L8.61512 3.71053L9.19766 0.470493C9.11079 0.392543 8.99714 0.348511 8.87812 0.348511L3.14558 0.34854Z"
        fill="black"
      />
      <path d="M10.0006 1.40771L11.9577 3.71047L9.58594 3.71047L10.0006 1.40771Z" fill="black" />
      <path d="M4.50222 9.4252L0.0615234 4.66248H2.93552L4.50222 9.4252Z" fill="black" />
      <path
        d="M6.11042 10.8111C6.07829 10.8176 6.04497 10.8212 6.01165 10.8212C5.99618 10.8212 5.98071 10.8206 5.96583 10.8188L3.94092 4.6626H8.3347L6.11042 10.8111Z"
        fill="black"
      />
      <path d="M7.69482 9.23951L11.9625 4.66248H9.35079L7.69482 9.23951Z" fill="black" />
      <path d="M2.10207 1.31555L2.67687 3.71062L0.0664062 3.71062L2.10207 1.31555Z" fill="black" />
    </svg>
  );
};
